// extracted by mini-css-extract-plugin
module.exports = {"link":"styles-module--link--1LAYj"};